


























import { Vue, Component } from "vue-property-decorator";
import { Action } from "vuex-class";

import { Languages } from "./i18n";

@Component
export default class App extends Vue {
  @Action
  changeLocale!: Function;
}
